import React from "react";
import data1 from "../../data/home1/projects/projects1";
function Projects() {
  const all = [...data1.interior, ...data1.construction];
  const featured = Object.values(data1)
    .flat()
    .filter(
      (project) => project.sub1 === "Featured" || project.sub2 === "Featured"
    );
  const interior = data1.interior;
  const construction = data1.construction;

  return (
    <section id="projects" className="tc-projects-style1">
      <div className="container">
        <div className="title mb-70 pt-50">
          <h2 className="fsz-45"> Our Projects </h2>
        </div>
        <div className="tabs-links mb-50">
          <div className="row align-items-center">
            <div className="col-lg-9">
              <ul className="nav nav-pills mb-3" id="pills-tab" role="tablist">
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link active"
                    id="pills-proj-all-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#pills-proj-all"
                    type="button"
                    role="presentation"
                  >
                    All
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link"
                    id="pills-proj-featured-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#pills-proj-featured"
                    type="button"
                    role="presentation"
                  >
                    Featured
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link"
                    id="pills-proj-interior-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#pills-proj-interior"
                    type="button"
                    role="presentation"
                  >
                    Interior
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link"
                    id="pills-proj-construction-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#pills-proj-construction"
                    type="button"
                    role="presentation"
                  >
                    Construction
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="projects">
          <div className="tab-content" id="pills-tabContent">
            <div
              className="tab-pane fade show active"
              id="pills-proj-all"
              role="tabpanel"
              aria-labelledby="pills-proj-all-tab"
            >
              <div className="projects-content float_box_container">
                <div className="projects-slider">
                  <div className="swiper-wrapper">
                    {all.map((item, i) => (
                      <div key={i} className="swiper-slide">
                        <div className="project-card">
                          <a
                            href={item.img}
                            className="img"
                            data-fancybox={`proj-all-${i}`}
                          >
                            <img src={item.img} alt="" className="img-cover" />
                          </a>

                          <div className="info">
                            <div className="tags">
                              <a href="#"> {item.sub1} </a>
                              {item.sub2 ? <a href="#"> {item.sub2} </a> : null}
                            </div>
                            <h3 className="title">
                              <a href="#"> {item.title} </a>
                            </h3>
                            <div className="text">{item.desc}</div>
                          </div>

                          {item.imgs.map((img, index) => (
                            <a
                              key={`proj-all-${i}-${index}`}
                              href={img}
                              className="img"
                              data-fancybox={`proj-all-${i}`}
                              style={{ display: "none" }}
                            >
                              <img
                                src={img}
                                alt=""
                                className="img-cover"
                                loading="lazy"
                              />
                            </a>
                          ))}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
                <div className="float-cursor float_box">
                  Hold <br /> and Drag
                </div>
              </div>
            </div>

            <div
              className="tab-pane fade"
              id="pills-proj-featured"
              role="tabpanel"
              aria-labelledby="pills-proj-featured-tab"
            >
              <div className="projects-content float_box_container">
                <div className="projects-slider">
                  <div className="swiper-wrapper">
                    {featured.map((item, i) => (
                      <div key={i} className="swiper-slide">
                        <div className="project-card">
                          <a
                            href={item.img}
                            className="img"
                            data-fancybox={`proj-featured-${i}`}
                          >
                            <img src={item.img} alt="" className="img-cover" />
                          </a>

                          <div className="info">
                            <div className="tags">
                              <a href="#"> {item.sub1} </a>
                              {item.sub2 ? <a href="#"> {item.sub2} </a> : null}
                            </div>
                            <h3 className="title">
                              <a href="#"> {item.title} </a>
                            </h3>
                            <div className="text">{item.desc}</div>
                          </div>

                          {item.imgs.map((img, index) => (
                            <a
                              key={`proj-featured-${i}-${index}`}
                              href={img}
                              className="img"
                              data-fancybox={`proj-featured-${i}`}
                              style={{ display: "none" }}
                            >
                              <img
                                src={img}
                                alt=""
                                className="img-cover"
                                loading="lazy"
                              />
                            </a>
                          ))}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
                <div className="float-cursor float_box">
                  Hold <br /> and Drag
                </div>
              </div>
            </div>

            <div
              className="tab-pane fade"
              id="pills-proj-interior"
              role="tabpanel"
              aria-labelledby="pills-proj-interior-tab"
            >
              <div className="projects-content float_box_container">
                <div className="projects-slider">
                  <div className="swiper-wrapper">
                    {interior.map((item, i) => (
                      <div key={i} className="swiper-slide">
                        <div className="project-card">
                          <a
                            href={item.img}
                            className="img"
                            data-fancybox={`proj-interior-${i}`}
                          >
                            <img src={item.img} alt="" className="img-cover" />
                          </a>

                          <div className="info">
                            <div className="tags">
                              <a href="#"> {item.sub1} </a>
                              {item.sub2 ? <a href="#"> {item.sub2} </a> : null}
                            </div>
                            <h3 className="title">
                              <a href="#"> {item.title} </a>
                            </h3>
                            <div className="text">{item.desc}</div>
                          </div>

                          {item.imgs.map((img, index) => (
                            <a
                              key={`proj-interior-${i}-${index}`}
                              href={img}
                              className="img"
                              data-fancybox={`proj-interior-${i}`}
                              style={{ display: "none" }}
                            >
                              <img
                                src={img}
                                alt=""
                                className="img-cover"
                                loading="lazy"
                              />
                            </a>
                          ))}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
                <div className="float-cursor float_box">
                  Hold <br /> and Drag
                </div>
              </div>
            </div>

            <div
              className="tab-pane fade"
              id="pills-proj-construction"
              role="tabpanel"
              aria-labelledby="pills-proj-construction-tab"
            >
              <div className="projects-content float_box_container">
                <div className="projects-slider">
                  <div className="swiper-wrapper">
                    {construction.map((item, i) => (
                      <div key={i} className="swiper-slide">
                        <div className="project-card">
                          <a
                            href={item.img}
                            className="img"
                            data-fancybox={`proj-construction-${i}`}
                          >
                            <img src={item.img} alt="" className="img-cover" />
                          </a>
                          <div className="info">
                            <div className="tags">
                              <a href="#"> {item.sub1} </a>
                              {item.sub2 ? <a href="#"> {item.sub2} </a> : null}
                            </div>
                            <h3 className="title">
                              <a href="#"> {item.title} </a>
                            </h3>
                            <div className="text">{item.desc}</div>
                          </div>

                          {item.imgs.map((img, index) => (
                            <a
                              key={`proj-construction-${i}-${index}`}
                              href={img}
                              className="img"
                              data-fancybox={`proj-construction-${i}`}
                              style={{ display: "none" }}
                            >
                              <img
                                src={img}
                                alt=""
                                className="img-cover"
                                loading="lazy"
                              />
                            </a>
                          ))}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
                <div className="float-cursor float_box">
                  Hold <br /> and Drag
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Projects;

// {
//   "title": "The Old Office",
//   "sub1": "Interior",
//   "sub2": "Furniture",
//   "desc": "Blending eclectic style with nature through earthy tones that celebrate its lush surroundings, it’s full of memories and meaningful little pieces, at first glance it might look a little old but in every corner there’s a lot of love. instead of simply being well decorated, we loved the open wall in the front with little nooks that show the smiling faces of our loved ones and the places we have been.",
//   "img": "/home1/assets/img/projects/proj1.jpg",
//   "imgs": []
// },
// {
//   "title": "New Guiza Villa",
//   "sub1": "Featured",
//   "sub2": "Architecture",
//   "desc": "A sophisticated statement of 60`s couple dreaming about their “dream house “, However, having high-end finishes in your home signifies an elevated standard of living, showcasing a commitment to quality, aesthetics, and comfort. It means that you have invested in top-tier materials, craftsmanship, and design to create an environment that exudes sophistication and luxury. High-end home finishes are often found in upscale homes, custom residences, or properties that prioritize both functionality and aesthetics.",
//   "img": "/home1/assets/img/projects/proj1.jpg",
//   "imgs": []
// },
// {
//   "title": "Ashgar Duplex",
//   "sub1": "Furniture",
//   "sub2": "Interior",
//   "desc": "Changing the mood, the mindset from a situation to another, that`s what our newly married couple are wishing for: to recline in relaxed luxury. Our team was lucky to have this project using every inch to maximize space utilization with high level of finishes.",
//   "img": "/home1/assets/img/projects/proj1.jpg",
//   "imgs": []
// }
